import React from 'react';
import { PillButton, Stack, Text } from 'library/ui';

export function PreferredButton({
    preferredAll,
    preferredLocations,
    setOpenPreferredModal,
}: {
    preferredAll: boolean;
    preferredLocations: number;
    setOpenPreferredModal: (open: boolean) => void;
}) {
    const phrase = preferredLocations === 1 && !preferredAll ? 'location' : 'locations';

    return (
        <Stack gap="sm">
            <PillButton variant="secondary" onClick={() => setOpenPreferredModal(true)}>
                Add as a Preferred Worker
            </PillButton>
            <Text size="sm" tone="secondary">
                Currently a Preferred Worker at {preferredAll ? 'all' : preferredLocations ?? 0} {phrase}
            </Text>
        </Stack>
    );
}
